import { isPerProductFieldType } from '../../events/is-per-product-field-type.js';
export function refinePerProductPhase(field, context, path) {
    if (isPerProductFieldType(field.typeId) &&
        field.config.phase !== 'beforeStart' &&
        field.config.phase !== 'afterStart') {
        context.addIssue({
            code: 'custom',
            message: 'A per-product field is filled in before or after the event starts, not at creation.',
            path: [...path, 'phase'],
        });
    }
}
//# sourceMappingURL=refine-per-product-phase.js.map